import React, { useEffect, useState } from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import axios from 'axios'
import moment from 'moment'
import PaginationComponent from '../../components/Pagination/Pagination';
import SpinnerComponents from '../../components/Spinner/SpinnerComponents';
import NewsSlide from '../../components/NewsSlide/NewsSlide';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNews } from '../../redux/actions/newsactions';
import './News.css'

const News = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 6;
  
  let totalItems;
  let totalPages;
  let currentItems = [];

  const newsinfo = useSelector(state => state.news)
  const dispatch = useDispatch()

  const format2 = "YYYY-MM-DD"
  const regex = /(<([^>]+)>)/gi;

  useEffect(() => {
    dispatch(fetchNews())
  }, [dispatch])

  useEffect(() => {
    if (newsinfo && newsinfo.news && newsinfo.news.results) {
      setData(newsinfo.news.results)
      setLoading(false)
    } else if (newsinfo && newsinfo.news && Array.isArray(newsinfo.news)) {
      setData(newsinfo.news)
      setLoading(false)
    }
  }, [newsinfo])

  // Calculate pagination
  if (data && data.length > 0) {
    totalItems = data.length;
    totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="news-page">
      <NewsSlide/>
      
      <Container>
        {/* Page Header */}
        <div className="news-header">
          <h6 className="news-subtitle">Stay Informed</h6>
          <h1 className="news-title">Latest News & Updates</h1>
          <p className="news-description">
            Get the latest news, updates, and stories from YorkeTV
          </p>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="news-loading">
            <SpinnerComponents />
          </div>
        )}

        {/* News Grid */}
        {!loading && data && data.length > 0 ? (
          <>
            <Row className="news-grid">
              {currentItems && currentItems.map(item => (
                <Col xs={12} sm={6} md={6} lg={4} key={item.id} className="news-col">
                  <article className="news-card">
                    <Link to={`/news/${item.id}`} className="news-card-link">
                      <div className="news-image-wrapper">
                        <img 
                          src={item.Image} 
                          className="news-image" 
                          alt={item.title}
                          loading="lazy"
                        />
                        {item.category && (
                          <div className="news-category-badge">
                            {item.category.name}
                          </div>
                        )}
                      </div>
                      
                      <div className="news-card-content">
                        <h3 className="news-card-title">{item.title}</h3>
                        
                        {item.content && (
                          <p className="news-card-excerpt">
                            {(item.content).replace(regex, "").substring(0, 150)}...
                          </p>
                        )}
                        
                        <div className="news-card-meta">
                          <span className="news-date">
                            {moment(item.publish_date).format(format2)}
                          </span>
                          {item.Author && (
                            <>
                              <span className="news-separator">•</span>
                              <span className="news-author">{item.Author}</span>
                            </>
                          )}
                        </div>
                        
                        <div className="news-read-more">
                          Read More →
                        </div>
                      </div>
                    </Link>
                  </article>
                </Col>
              ))}
            </Row>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="news-pagination">
                <PaginationComponent
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </>
        ) : !loading && (
          <div className="news-empty">
            <p>No news articles available at the moment.</p>
          </div>
        )}
      </Container>
    </div>
  )
}

export default News
